export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";

export const ADD_PRODUCT_LIST = "ADD_PRODUCT_LIST";
export const REMOVE_PRODUCT_LIST = "REMOVE_PRODUCT_LIST";

export const UPDATE_TOTAL = "UPDATE_TOTAL ";
export const SET_ORDER_LIST = "SET_ORDER_LIST ";
